export default "__VITE_ASSET__BZZx1VLh__"